import axios from 'axios'
import enumFilterMap from '@/mixins/mapping/enumFilterMap'

const state = {
    addressesBuilding: {},
    addressesShelters: [],
    addressesShelter: {}, 
    addressesUser: {}, //Данные о собственнике помещения
    addressNextCheckupDate: '',
    addressCheckupStatus: false, //Сообщает о добавлении проверки для перезагрузки страницы с проверками
    addressLocation: '' //Определяет на какой странице находится юзер: адрес, помещение
};

const getters = {
    addressesBuilding: state => {
        return state.addressesBuilding
    },
    addressesShelters: state => {
        return state.addressesShelters
    },
    addressesShelter: state => {
        return state.addressesShelter
    },
    addressesUser: state => {
        return state.addressesUser
    },
    addressNextCheckupDate: state => {
        return state.addressNextCheckupDate
    },
    addressCheckupStatus: state => {
        return state.addressCheckupStatus
    },
    addressLocation: state => {
        return state.addressLocation
    }
};

const mutations = {
    addressesBuilding: (state, payload) => {
        return state.addressesBuilding = payload
    },
    addressesShelters: (state, payload) => {
        return state.addressesShelters = payload
    },
    addressesShelter: (state, payload) => {
        return state.addressesShelter = payload
    },
    addressesUser: (state, payload) => {
        return state.addressesUser = payload
    },
    addressNextCheckupDate: (state, payload) => {
        return state.addressNextCheckupDate = payload
    },
    addressCheckupStatus: (state) => {
        return state.addressCheckupStatus = !state.addressCheckupStatus
    },
    addressLocation: (state, location) => {
        return state.addressLocation = location
    }
};

const actions = {
//GET
    addressesGetBuilding({commit}, id) {
    //Получение и хранение данных о здании
        return axios({
                method: 'get', 
                url: 'building/' + id
            })
            .then(response => {
                commit('addressesBuilding', response.data.data)
                return response
            })
            .catch(err => {
                console.error('Ошибка загрузки данных о здании: ', err)
            })
        },
    addressesGetShelter({commit}, id) {
        //Получение и хранение данных о одном помещении
        return axios({
            method: 'GET', 
            url: 'property/' + id
        })
        .then(response => {
            const shelter = response.data.data 
            
            commit('addressesShelter', shelter)
            return response
        })
        .catch(err => {
            console.error('Ошибка загрузки данных о помещении: ', err)
        })
    },
    addressesGetShelters({commit}, id) {
        return axios({
            url: 'property',
            params: {
                pg: 0,
                batch: 10,
                buildingId: id
            }
        })
        .then(({data}) => {
            commit('addressesShelters', data.data)
        })
        .catch(error => {
            console.log('Ошибка при загрузке помещений: ', err.response)
        })
        
    },
    addressesGetUser({commit}, id) {
        return axios({
                method: 'GET',
                url: 'profiles/' + id
            })
            .then(response => {  
                commit('addressesUser', response.data.data)
            })
            .catch(err => {
                console.error('Ошибка при загрузке данных пользователя: ', err)
            })
    },

//PATCH
    addressesEditBuilding({commit}, buildingData) {
        return axios({
            method: 'PATCH',
            url: 'building/' + buildingData.id,
            data: {data: buildingData}
        })
        .catch(err => {
            console.error('Ошибка сохранения здания: ', err)
        })
    },
    addressesEditShelter({commit}, propertyData) {
        return axios({
            method: 'PATCH',
            url: 'property/' + propertyData.id,
            data: {data: propertyData}
        })
        .catch(err => {
            console.error('Ошибка сохранения помещения: ', err)
        })
    },

    
    addressesShelter({commit}, shelter) {
        commit('addressesShelter', shelter)
    },
    addressesEnumFilterMap({commit}, payload) {
            //type get - получаем
            //type send - отправляем
            //value - значение которое необходимо перевести
            //lib - варианты для мапинга
            let mapResult = ''

            if (payload.type === 'get') {
                //При получении данных
                payload.lib.forEach(item => {
                    if (item.value === payload.value) {
                        mapResult =  item.name
                    }
                })
            }

            if (payload.type === 'send') {
                //При получении данных
                payload.lib.forEach(item => {
                    if (item.value === payload.value) {
                        mapResult = item.value
                    }
                })
            }

            return mapResult
    },
    addressNextCheckupDate({commit}, payload) {
        commit('addressNextCheckupDate', payload)
    },
    addressCheckupStatus({commit}) {
        commit('addressCheckupStatus')
    },
    addressLocation({commit}, location) {
        commit('addressLocation', location)
    }
};

export default {
    state,
    getters,
    mutations,
    actions
}